import styled from "@emotion/styled"

import { StyledClickable } from "../link/link-styles"

const StyledButton = styled.button`
  ${StyledClickable}
`

export default StyledButton
